//import liraries
import React, { Component } from 'react';
import { View, Text, StyleSheet,Image } from 'react-native';
import { FONTS } from '../constant';
import CText from './CText';
import ImagePopup from '../SubComponents/Disputes/ImagePopup';

// create a component
const CTiCertificateWrapper = (props) => {
    return (
        <View
        style={{
          flexDirection: "row",
          justifyContent: "space-between",
          width: "110%",
          alignItems: "center",
          marginVertical:5,
          paddingHorizontal:30
        }}
      >
        <CText.benifitText style={{ flex: 0.9, textAlign: "left",alignSelf:"center" }}>
          {props.keyText}
        </CText.benifitText>
        <CText.benifitText style={{ flex: 0.2 }}>{":"}</CText.benifitText>
        {props?.images?.length>0 ?
        <View style={{
          flexDirection: "row",
          flex: 0.9,

        }} >
          { 
           props.images?.map(item=>{
            return <Image 
          source={{ uri: `data:image/png;base64,${item}` }} 
          style={{width:40,height:40,marginRight:10}}/>
           })
          } </View>
         :
         <CText.benifitText style={{ flex: 0.9,fontFamily:FONTS.InterBold }}>
         {props.valueText}
        </CText.benifitText>
         }
         {/* <ImagePopup imageUrl = {}/> */}
      </View>
    );
};

// define your styles
const styles = StyleSheet.create({
    container: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#2c3e50',
    },
});

//make this component available to the app
export default CTiCertificateWrapper;
